import MobileTabSwitcher from "@components/switcher/MobileTabSwitcher";
import { isPaysonicHost } from "src/config/deploymentConfig";
import PlatformBalances from "../../balances/platform-balances/PlatformBalances";
import UserBalances from "../../balances/user-balances/UserBalances";

const MobileBalancesTabs = () => {
  const isPaysonic = isPaysonicHost();

  const balanceTabs = isPaysonic
    ? [{ label: "User Balances", component: <UserBalances /> }]
    : [
        { label: "User Balances", component: <UserBalances /> },
        { label: "Platform Balances", component: <PlatformBalances /> },
      ];

  return (
    <div
      className="flex flex-col w-full"
      style={{ height: "calc(100dvh - 56px)" }}
    >
      <div className="h-[56px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 px-4 w-full shrink-0">
        <div className="flex flex-row items-center w-full">
          <p className="text-text-base text-[14px] font-semibold">Balances</p>
        </div>
      </div>
      <div className="flex flex-col flex-1 min-h-0 mt-4 px-3">
        <MobileTabSwitcher tabs={balanceTabs} />
      </div>
    </div>
  );
};

export default MobileBalancesTabs;
